import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminHomePage from './pages/AdminHomePage';
import AdminMembersPage from './pages/AdminMembersPage';
import AdminAttendancePage from './pages/AdminAttendancePage';
import AdminAttendanceCheckPage from './pages/AdminAttendanceCheckPage';
import AdminGroupMessagePage from './pages/AdminGroupMessagePage';
import WelcomePage from './pages/WelcomePage';
import { useAuth } from './context/AuthContext';
import { getHomePathForUser, getUserRole } from './api/auth';

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="auth-loading">로그인 상태를 확인하고 있습니다...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const StudentHomeRoute: React.FC = () => {
  const { user } = useAuth();

  if (getUserRole(user) === 'admin') {
    return <Navigate to="/admin/home" replace />;
  }

  return <HomePage />;
};

const AdminHomeRoute: React.FC = () => {
  const { user } = useAuth();

  if (getUserRole(user) !== 'admin') {
    return <Navigate to={getHomePathForUser(user)} replace />;
  }

  return <AdminHomePage />;
};

const AdminOnlyRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user } = useAuth();

  if (getUserRole(user) !== 'admin') {
    return <Navigate to={getHomePathForUser(user)} replace />;
  }

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route
          path="/home"
          element={
            <RequireAuth>
              <StudentHomeRoute />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/home"
          element={
            <RequireAuth>
              <AdminHomeRoute />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/members"
          element={
            <RequireAuth>
              <AdminOnlyRoute>
                <AdminMembersPage />
              </AdminOnlyRoute>
            </RequireAuth>
          }
        />
        <Route
          path="/admin/attendance"
          element={
            <RequireAuth>
              <AdminOnlyRoute>
                <AdminAttendancePage />
              </AdminOnlyRoute>
            </RequireAuth>
          }
        />
        <Route
          path="/admin/attendance-check"
          element={
            <RequireAuth>
              <AdminOnlyRoute>
                <AdminAttendanceCheckPage />
              </AdminOnlyRoute>
            </RequireAuth>
          }
        />
        <Route
          path="/admin/group-message"
          element={
            <RequireAuth>
              <AdminOnlyRoute>
                <AdminGroupMessagePage />
              </AdminOnlyRoute>
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
